import { render } from "./securityIndex.vue?vue&type=template&id=a8dea7c2"
import script from "./securityIndex.vue?vue&type=script&lang=js"
export * from "./securityIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__